import { ReactNode } from 'react';
import { Skeleton } from 'ui';

interface InfoDetailsSetProps {
  loading?: boolean;
  set: { label: string | ReactNode; value: ReactNode }[];
}

const InfoDetailsSet = ({ set, loading = false }: InfoDetailsSetProps) => {
  return (
    <div>
      {set.map(({ label, value }, index) => (
        <div
          key={index}
          className="grid grid-cols-[45%_55%] gap-2 [&:not(:first-child)]:pt-4 [&:not(:last-child)]:pb-4 [&:not(:last-child)]:border-b border-gray-200"
        >
          <span className="text-sm text-gray-500">{label}</span>
          <span className="text-sm text-gray-900 break-words" style={{ wordBreak: 'break-word' }}>
            {loading && <Skeleton />}
            {!loading && (typeof value === 'string' ? value || '-' : value ?? '-')}
          </span>
        </div>
      ))}
    </div>
  );
};

export default InfoDetailsSet;
